import { useEffect, useState } from 'react';

export const MOBILE_QUERY = '(max-width: 900px)';

// Reactive boolean: true when the viewport is phone-sized. Single source of the
// mobile breakpoint, mirrored by the @media (max-width:900px) block in CSS.
export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(MOBILE_QUERY).matches,
  );
  useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener('change', onChange);
    setIsMobile(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, []);
  return isMobile;
}
